import PropTypes from 'prop-types'
import { Bar } from 'react-chartjs-2'

const centerStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '300px',
  color: '#9ca3af',
  fontStyle: 'italic'
}

const barChartOptions = {
  indexAxis: 'y',
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { display: false },
    tooltip: {
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      titleColor: '#fff',
      bodyColor: '#fff',
      borderColor: '#374151',
      borderWidth: 1
    },
    datalabels: {
      display: true,
      anchor: 'end',
      align: 'end',
      color: '#e5e7eb',
      formatter: (value) => value
    }
  },
  scales: {
    x: {
      beginAtZero: true,
      ticks: { color: '#e5e7eb' },
      grid: { color: '#374151' }
    },
    y: {
      ticks: { color: '#e5e7eb', font: { size: 11 } },
      grid: { color: '#374151' }
    }
  },
  elements: { bar: { borderSkipped: false } },
  layout: { padding: { right: 40 } }
}

const DeviceModelChart = ({ title, models, loading, error, backgroundColor, borderColor, emptyMessage }) => (
  <div style={{
    flex: '1',
    backgroundColor: '#1f2937',
    padding: '20px',
    borderRadius: '8px',
    border: '1px solid #374151',
    minHeight: '400px'
  }}>
    <h3 style={{
      color: '#e5e7eb',
      textAlign: 'center',
      marginBottom: '16px',
      fontSize: '16px',
      fontWeight: '600'
    }}>
      {title}
    </h3>
    {(() => {
      if (error) {
        return <div className="error-message">{error}</div>
      }
      if (loading) {
        return <div style={centerStyle}>Load {title.replace('Top 10 ', '')} Data...</div>
      }
      return (
        <div style={{ height: '300px' }}>
          {models.length > 0 ? (
            <Bar
              data={{
                labels: models.map(model => model.device_model),
                datasets: [{
                  label: 'Count',
                  data: models.map(model => model.count),
                  backgroundColor,
                  borderColor,
                  borderWidth: 1
                }]
              }}
              options={barChartOptions}
            />
          ) : (
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: '100%',
              color: '#9ca3af',
              fontStyle: 'italic'
            }}>
              {emptyMessage}
            </div>
          )}
        </div>
      )
    })()}
  </div>
)

DeviceModelChart.propTypes = {
  title: PropTypes.string.isRequired,
  models: PropTypes.arrayOf(PropTypes.shape({
    device_model: PropTypes.string,
    count: PropTypes.number
  })).isRequired,
  loading: PropTypes.bool.isRequired,
  error: PropTypes.string,
  backgroundColor: PropTypes.string.isRequired,
  borderColor: PropTypes.string.isRequired,
  emptyMessage: PropTypes.string.isRequired
}

export default DeviceModelChart
